/**
 * Installs global browser error filters for known, harmless noise.
 *
 * Currently suppresses:
 * - "ResizeObserver loop completed with undelivered notifications."
 *
 * Only these exact messages are ignored; all other errors still surface
 * in the console so real issues remain visible.
 */
export function installBrowserErrorFilters(): void {
  if (typeof window === 'undefined') return;

  const ignoredMessages = new Set<string>([
    'ResizeObserver loop completed with undelivered notifications.',
  ]);

  window.addEventListener('error', (event) => {
    if (event.message && ignoredMessages.has(event.message)) {
      event.stopImmediatePropagation();
    }
  });
}
